/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { ReactNode } from 'react';
import { blockMidPadding } from './settings-block.styles';

/**
 * The wrapper for a mid whose content an existing component already draws.
 *
 * The `matrix` mid uses it: the permission accordion fetches its own data
 * and expands its own categories, and the prototype's flat seven-row grid
 * does not describe that. The mid contributes the block's spacing contract
 * and lets the accordion fill it.
 *
 * The `people` mid started out hosted this way too, around `MembersTable`.
 * That was wrong — a data table's header band and column rhythm are exactly
 * what the prototype's list avoids, and it pushed the team under the fold.
 * It is now drawn properly in `PeopleBlock`.
 *
 * @param props - Component props.
 * @param props.children - The hosted table or accordion.
 * @returns The mid wrapper.
 */
export function BlockMid({ children }: { children: ReactNode }) {
  return <div style={{ padding: blockMidPadding }}>{children}</div>;
}
